/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
==========================================================================================*/

import jwt from "../../http/requests/user-management/index.js"
import index from '@/http/requests/admin/index.js'
import axios from "@/axios.js"

export default {
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/user-management/users")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  UpdateProfileAccount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.UpdateProfileAccount(payload.nom, payload.prenom, payload.email, payload.id)
        .then(response => {
           if (response.data) {
            // Update user details
            commit('UPDATE_USER_INFO_Account', response.data, { root: true })
            resolve(response)
          } else {
            reject({ message: "Wrong Email or Password" })
          }
        })
        .catch(error => { console.log(error) 
          reject(error) })
    })
  },
  UpdateProfileInformation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.UpdateProfileInformation(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.id) {
            // Update user details
            commit('UPDATE_USER_INFO_Information', response.data, { root: true })

            resolve(response)
          } else {
            reject({ message: "Wrong Email or Password" })
          }

        })
        .catch(error => { reject(error) })
    })
  },

  UpdateProfileSocial({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.UpdateProfileSocial(payload)
        .then(response => {
          // If there's user data in response
          if (response.data) {
            // Update user details
            commit('UPDATE_USER_INFO_Social', response.data, { root: true })
            resolve(response)
          } else {
            reject({ message: response.data })
          }

        })
        .catch(error => { reject(error) })
    })
  },
  GetLocations() {
    return new Promise((resolve, reject) => {
      jwt.GetLocations()
        .then(response => {
          if (response.data) {
            resolve(response)
          }
        })
        .catch(error => { reject(error) })
    })
  },
  UpdateSociete({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.UpdateSociete(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.id) {
            // Update user details
            commit('UPDATE_USER_INFO', response.data, { root: true })

            resolve(response)
          } else {
            reject({ message: "Wrong Email or Password" })
          }

        })
        .catch(error => { reject(error) })
    })
  },
  UpdateProfileConfide({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.UpdateProfileConfide(payload)
        .then(response => {
          console.log(response.data.username)
          // If there's user data in response
          if (response.data.username) {
            // Update user details
            const accessToken = response.headers.authorization;
            localStorage.setItem('accessToken', accessToken);
            commit('UPDATE_USER_INFO_USERNAME', response.data, { root: true })

            resolve(response)
          } else {
            reject({ 'response': "erreur inconnu" })
          }

        })
        .catch(error => {   reject(error) })
    })
  },

  GetImage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.GetImage(payload)
        .then(response => {
          // If there's user data in response
          // Update user details
          if (response.data)
            commit('UPDATE_USER_IMAGE', response.data, { root: true })

          resolve(response)


        })
        .catch(error => { reject(error) })
    })
  },

  UpdateImage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.UpdateImage(payload)
        .then(response => {
          // If there's user data in response

          // Update user details
          commit('UPDATE_USER_IMAGE', response.data, { root: true })

          resolve(response)


        })
        .catch(error => { reject(error) })
    })
  },
  getListFournisseur({commit}){
    index.getListFournisseur().then(response=>{
      commit('UPDATE_LIST_FOURNISSEUR',response.data)
    })
  },
  getListLivreur({commit}){
    index.getListLivreurs().then(response=>{
     
      commit('UPDATE_LIST_LIVREURS',response.data)
    })
  }
}
